import React from 'react';

import classes from './Spinner.css';

const spinner = (props) => {
    let className = classes.Loader;
    if(props.gray){
        className = classes.LoaderGray;
    }
    return ( <div className={className} style={{ fontSize:props.fontSize , margin:props.margin }}>Loading...</div>)
};

export default spinner;